import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface SearchButtonProps extends FlexProps {
  children: ReactNode;
}

export function SearchButton({ children, ...rest }: SearchButtonProps) {
  return (
    <Flex
      borderRadius={"3px"}
      as="label"
      flex="1"
      paddingY="4"
      paddingX="8"
      marginLeft="6"
      alignSelf="center"
      alignItems="center"
      color="gray.200"
      position="relative"
      justify="center"
      bg="yellow.900"
      maxWidth="80px"
      w="50px"
      h={["36px", "48px"]}
      // transform="skew(-20deg)"
      _hover={{ opacity: "0.9" }}
      {...rest}
    >
      {children}
    </Flex>
  );
}
